/**
 * Get translation for provided translation key.
 *
 * @param {String} key Key to translate.
 * @param {Object} params Replacement values for translation.
 * @return {String} Translated string. Empty string is returned if no translation is found.
 */
function translate(key, params) {
  return window._translations && window._translations[key] ? replacePlaceholders(window._translations[key], params) : '';
}

/**
 * Replaces placeholders with provided values.
 *
 * @param {String} string String with placeholders.
 * @param {Object} params Replacement values for provided string.
 * @return {String} Resulted string.
 */
function replacePlaceholders(string, params) {
  let result = string;
  if (typeof params === 'object') {
    for (let key in params) {
      result = result.split('%' + key + '%').join(params[key]);
    }
  }
  return result;
}

export {
  translate,
  replacePlaceholders
};
